/* eslint-disable no-use-before-define */
import React from 'react'
import {arrayFrom} from '../../../twd'

export default ({stroke, width, height, x, y, top, payload}) => {

    if (!x) return null

    let a = arrayFrom(payload)[0]
    if (!a) return null
    let p = a.payload
    if (!p || !p.benchmark) return null

    let args = {
        x, y, stroke, width, height,
        className: 'recharts-cross recharts-tooltip-cursor',
        pointerEvents: 'none',
        strokeDasharray: '5',
        d: `M${x},${top}v${height}`
    }
    return <path {...args} />
}
